import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, delay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class LoaderService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.loadingSubject.asObservable();

  constructor(private ngZone: NgZone) { }

  private setLoading(value: boolean): void {
    this.ngZone.runOutsideAngular(() => {
      Promise.resolve().then(() => {
        this.ngZone.run(() => {
          this.loadingSubject.next(value);
        });
      });
    });
  }

  show(): void {
    this.setLoading(true);
  }

  hide(): void {
    this.setLoading(false);
  }

  getCurrentState(): boolean {
    return this.loadingSubject.getValue();
  }
} 
